module.exports = __webpack_public_path__ + "static/media/iphone-case.f1d4c883.png";